// Auto-generated by scripts/sync-app-version.js — do not edit.
export const APP_VERSION = '0.2.0';
export const APP_BUILD_TIME = '2026-10-23T11:48:58.563Z';
